
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/advanced-features",
      function () {
        return require("private-next-pages/docs/advanced-features.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/advanced-features"])
      });
    }
  